export default __webpack_public_path__ + "static/Washington-8bb885575a605415f8ecb63335858504.webp";